import {
  CommunicationDirection,
  EmailDeliveryStatus,
  IBrand,
  IContactEmailContactDetails,
  EmailMessage as IEmailMessage,
  IEmailReplyTokenData,
  IOrganisation,
} from '@principle-theorem/principle-core/interfaces';
import {
  asReffable,
  AtLeast,
  DocumentReference,
  Firestore,
} from '@principle-theorem/shared';
import {
  createCSRF,
  ITemporaryOrgDataToken,
} from '@principle-theorem/temporary-tokens';
import * as moment from 'moment-timezone';
import { Organisation } from '../organisation/organisation';

export class EmailMessage {
  static init<
    T extends IContactEmailContactDetails = IContactEmailContactDetails,
  >(
    data: AtLeast<
      IEmailMessage<T>,
      | 'subject'
      | 'text'
      | 'html'
      | 'recipientEmail'
      | 'recipientRef'
      | 'practiceEmail'
      | 'practiceRef'
      | 'replyData'
    >
  ): IEmailMessage {
    return {
      readBy: [],
      authorRef: data.authorRef,
      direction: CommunicationDirection.Outbound,
      status: EmailDeliveryStatus.Pending,
      deleted: false,
      ...data,
    } as IEmailMessage;
  }

  static async generateReplyToken(
    tokenData: IEmailReplyTokenData
  ): Promise<DocumentReference<ITemporaryOrgDataToken<IEmailReplyTokenData>>> {
    const brandRef = Firestore.getParentDocRef<IBrand>(tokenData.practiceRef);
    const organisationRef = Firestore.getParentDocRef<IOrganisation>(brandRef);
    const tokenExpiry = moment().add(6, 'months');
    const csrf = await createCSRF(
      Organisation.temporaryTokenCol(asReffable(organisationRef)),
      tokenData,
      tokenExpiry,
      moment(tokenExpiry).add(1, 'month'),
      true
    );

    return csrf.ref as DocumentReference<
      ITemporaryOrgDataToken<IEmailReplyTokenData>
    >;
  }
}
